class Base {
  constructor (name) {
    this.name = name
  }
}

export default Base
